import appCONST from 'constants/app.constants';

export default function HttpDecorator($provide) {
    'ngInject';

    $provide.decorator('$http', function($delegate) {
        'ngInject';

        _.forEach(['get', 'post', 'put', 'delete'], (method) => {
            $delegate['api' + method.toUpperCase()] = function() {
                const args = [].slice.call(arguments);
                const setHeaders = {};
                if (args.length) {

                    //if (args[0].indexOf('atc-api.itravelmix.net') !== -1) {
                    //    setHeaders['Content-Type'] = 'application/json';
                    //} else {

                        args[0] = appCONST.apiUrl + args[0];
                        if (method === 'post' && args[0].indexOf('login') !== -1) {
                            setHeaders['Content-Type'] = 'application/json';
                        }
                    //}

                }
                return $delegate[method].apply(null, args, setHeaders);
            };
        });
        return $delegate;
    });
}



// WEBPACK FOOTER //
// ./src/app/configs/http.decorator.config.js